import { render, staticRenderFns } from "./ClassPanel.vue?vue&type=template&id=f29b0d46&scoped=true&"
import script from "./ClassPanel.vue?vue&type=script&lang=ts&"
export * from "./ClassPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ClassPanel.vue?vue&type=style&index=0&id=f29b0d46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29b0d46",
  null
  
)

export default component.exports